module.exports = __webpack_public_path__ + "images/Ilan_ben_meir.jpg?v=fcef82f565054bb7457394ebd1d0a240";